// @flow

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import threads from './threads';
import messages from './messages';
import type { ThreadsState } from './threads';
import type { MessagesState } from './messages';

export type State = {
  threads: ThreadsState,
  messages: MessagesState,
};

export default combineReducers({
  router: routerReducer,
  threads,
  messages,
});



// WEBPACK FOOTER //
// ./src/modules/messaging/reducers/index.js